import { useState } from "react";
import {
    ApprovalEvent,
    type LLMClassifierApprovalReviewer,
} from "models/LLMs/LLMClassifierApproval";
import { LLMClassifierBuilderStore } from "../../Stores/LLMClassifierBuilderStore";

export type ApprovalDialogName = "request" | "review" | "reject" | "changes";

export function useApprovalWorkflowDialogs(
    store: LLMClassifierBuilderStore,
    comparisonVersionId: string | undefined,
) {
    const [dialog, setDialog] = useState<ApprovalDialogName>();
    const [reviewers, setReviewers] = useState<
        LLMClassifierApprovalReviewer[]
    >([]);
    const [note, setNote] = useState("");
    const [reason, setReason] = useState("");
    const [approverName, setApproverName] = useState("");
    const [rejecterName, setRejecterName] = useState("");

    const isSaving = store.getTaskLoading(
        LLMClassifierBuilderStore.Tasks.RecordApprovalEvent,
    );
    const isLoadingReviewers = store.getTaskLoading(
        LLMClassifierBuilderStore.Tasks.LoadApprovalReviewers,
    );

    const closeDialog = () => setDialog(undefined);

    const openRequest = () => {
        setReviewers([]);
        setNote("");
        setDialog("request");
        void store.loadApprovalReviewers();
    };

    const submit = async (
        event: ApprovalEvent,
        options?: { comment?: string; reviewerIds?: string[] },
    ) => {
        const success = await store.recordApprovalEvent({
            event,
            requestedApproverUserIds: options?.reviewerIds,
            comparedToEntityId:
                event === ApprovalEvent.ApprovalRequested
                    ? comparisonVersionId
                    : undefined,
            comment: options?.comment?.trim() || undefined,
        });

        if (success) {
            setDialog(undefined);
            setReason("");
            setNote("");
            setApproverName("");
            setRejecterName("");
        }
    };

    return {
        dialog,
        setDialog,
        closeDialog,
        openRequest,
        reviewers,
        setReviewers,
        note,
        setNote,
        reason,
        setReason,
        approverName,
        setApproverName,
        rejecterName,
        setRejecterName,
        isSaving,
        isLoadingReviewers,
        submit,
    };
}
